import { render, staticRenderFns } from "./EmissionsTable.vue?vue&type=template&id=92e2cf1a&lang=html&"
import script from "./EmissionsTable.vue?vue&type=script&lang=js&"
export * from "./EmissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports